import { ActionType, createAction, createReducer } from 'typesafe-actions';
import { ConfigurationsState, DISABLE_SHOP_TO_CLUB } from '../../../common/types/remoteConfig';
import { defaultConfig } from '../../../common/defaultStates/remoteConfig';

export const disableShopToClub = createAction(DISABLE_SHOP_TO_CLUB);

export const actions = { disableShopToClub };

type ConfigurationActions = ActionType<typeof actions>;

export const configurationsReducer = createReducer<ConfigurationsState, ConfigurationActions>(
    defaultConfig
).handleAction(actions.disableShopToClub, state => ({
    ...state,
    shopToClub: {
        ...state.shopToClub,
        isEnabled: false,
    },
}));
